import IGeoCoordinate from "./IGeoCoordinate";
import Shape from "./Shape";

export default interface IFavorite {
    id: number;
    targetId: number;
    targetType: FavoriteTargetType;
    createdAt: Date;
}

export interface IFavoritePropertyDetails {
    id: number;
    centerPoint: IGeoCoordinate;
    shapes: Shape[];
    address: string;
    state: string;
    zip: string;
    city: string;
    notesJson: string | null;
}

export enum FavoriteTargetType {
    Property = "Property",
    Lead = "Lead",
    LeaseComp = "LeaseComp",
    SaleComp = "SaleComp",
    Deal = "Deal",
    TenantInMarket = "TenantInMarket",
    Company = "Company",
    SavedView = "SavedView",
}